import { Link as RouterLink } from 'react-router-dom';
import Cookies from 'js-cookie';
import Box from '@mui/joy/Box';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import { menuList } from '../../../config/consts';

const handleLogout = () => {
  Cookies.remove('at');
  window.location.reload();
};

export default function MenuList() {
  return (
    <Box
      role="sidebar-menu"
      // onClick={toggleDrawer(anchor, false)}
      // onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {menuList.map(({ label, link }) => (
          <ListItem key={label}>
            {label === 'Logout' ? (
              <ListItemButton onClick={handleLogout}>{label}</ListItemButton>
            ) : (
              <ListItemButton to={link} component={RouterLink}>
                {label}
              </ListItemButton>
            )}
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
